// extracted by mini-css-extract-plugin
export default {"img":"Loading_img__03fc+","loadingImage":"Loading_loadingImage__Tqxyo"};